/**
 * !!! IMPORTANT !!!
 * All editor components should get templates only
 * by methods of this module. Nothing within templates folder should
 * be imported from editor directly.
 */
import has from 'lodash/has'
import * as fashionIcon from './fashionIcon/template/index'
import * as outSide from './outSide/template/index'
import * as coffee from './coffee/template/index'
import * as appWebsite from './app-website/template/index'
import * as insta from './insta/template/index'
import * as bouncy from './bouncy/template/index'

const templatesRaw = {
  outSide,
  fashionIcon,
  coffee,
  appWebsite,
  insta,
  bouncy
}

export function getTemplateByApp (app, testGroup) {
  const templateRaw = templatesRaw[app.templateId]
  if (templateRaw) {
    return templateRaw.getTemplate(app, testGroup)
  } else {
    console.error('getTemplateByApp: unknown templateId', app.templateId)
  }
}

export function getTemplatesInfo () { // Returns array of templates' information objects
  return Object.keys(templatesRaw).map(template => getTemplateInfo(template))
}

export function getTemplateInfo (templateId) {
  return templatesRaw[templateId].information
}

export function isTemplateExists (templateId) {
  return templatesRaw.hasOwnProperty(templateId)
}

export function createDefaultCustomFields (templateId, slidesCnt) {
  const templateRaw = templatesRaw[templateId]
  if (has(templateRaw, 'createDefaultCustomFields')) {
    return templateRaw.createDefaultCustomFields(slidesCnt)
  } else {
    console.log('templateRaw has no createDefaultCustomFields', templateRaw)
    return {}
  }
}



// WEBPACK FOOTER //
// ./src/templates/templates.js